import {
  createContext,
  useContext,
  useMemo
} from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import GlobalErrorBoundary from '../components/GlobalErrorBoundary';

const AppContext = createContext({});

export function AppContextProvider(
  {
    store: {
      store,
      persistor
    },
    children
  }
) {
  const value = useMemo(() => ({}), []);
  return (
    <AppContext.Provider value={value}>
      <Provider store={store}>
        <GlobalErrorBoundary>
          <PersistGate
            loading={null}
            persistor={persistor}
          >
            {children}
          </PersistGate>
        </GlobalErrorBoundary>
      </Provider>
    </AppContext.Provider>
  );
}

export const useAppContext = () => useContext(AppContext);

AppContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  store: PropTypes.shape({
    store: PropTypes.object.isRequired,
    persistor: PropTypes.object.isRequired
  }).isRequired
};

export default AppContextProvider;
